import React, { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import { MessageSquare, LogOut, User, Bell } from 'lucide-react';

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_expert-connect-184/artifacts/zgfr8qi0_Consultant.svg";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-100 shadow-sm" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <Link 
            to="/"
            className="flex items-center cursor-pointer hover:opacity-80 transition-opacity"
            data-testid="logo"
          >
            <img src={LOGO_URL} alt="ConsultantHUB" className="h-14 w-auto" />
          </Link>

          <div className="flex items-center space-x-2">
            {/* Navigation Links */}
            <button
              onClick={() => navigate('/dashboard')}
              className="hidden md:block px-4 py-2 text-slate-600 hover:text-[#344B71] hover:bg-slate-50 rounded-lg font-medium transition-all"
              data-testid="nav-dashboard"
            >
              Dashboard
            </button>
            <button
              onClick={() => navigate('/listings')}
              className="hidden md:block px-4 py-2 text-slate-600 hover:text-[#344B71] hover:bg-slate-50 rounded-lg font-medium transition-all"
              data-testid="nav-listings"
            >
              Annunci
            </button>
            {user?.user_type === 'professional' && (
              <>
                <button
                  onClick={() => navigate('/favorites')}
                  className="hidden md:block px-4 py-2 text-slate-600 hover:text-[#344B71] hover:bg-slate-50 rounded-lg font-medium transition-all"
                  data-testid="nav-favorites"
                >
                  Preferiti
                </button>
                <button
                  onClick={() => navigate('/analytics')}
                  className="hidden md:block px-4 py-2 text-slate-600 hover:text-[#344B71] hover:bg-slate-50 rounded-lg font-medium transition-all"
                  data-testid="nav-analytics"
                >
                  Analytics
                </button>
              </>
            )}
            <button
              onClick={() => navigate('/faq')}
              className="hidden md:block px-4 py-2 text-slate-600 hover:text-[#344B71] hover:bg-slate-50 rounded-lg font-medium transition-all"
              data-testid="nav-faq"
            >
              FAQ
            </button>

            {/* Divider */}
            <div className="hidden md:block w-px h-8 bg-slate-200 mx-2" />

            {/* Action Buttons */}
            <button
              onClick={() => navigate('/messages')}
              className="relative p-2 text-slate-600 hover:text-[#344B71] hover:bg-slate-50 rounded-lg transition-all"
              data-testid="nav-messages"
            >
              <MessageSquare className="w-5 h-5" />
            </button>
            
            <button
              onClick={() => navigate('/profile')}
              className="p-2 text-slate-600 hover:text-[#344B71] hover:bg-slate-50 rounded-lg transition-all"
              data-testid="nav-profile"
            >
              <div className="w-8 h-8 bg-gradient-to-br from-[#344B71] to-[#344B71] rounded-full flex items-center justify-center text-white text-sm font-semibold">
                {user?.name?.charAt(0)?.toUpperCase() || 'U'}
              </div>
            </button>
            
            <Button
              onClick={handleLogout}
              variant="ghost"
              size="sm"
              className="text-slate-500 hover:text-red-500 hover:bg-red-50"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
